import { render } from "./SixnesErwtiseis.vue?vue&type=template&id=e2dbfe48&scoped=true"
import script from "./SixnesErwtiseis.vue?vue&type=script&lang=js"
export * from "./SixnesErwtiseis.vue?vue&type=script&lang=js"

import "./SixnesErwtiseis.vue?vue&type=style&index=0&id=e2dbfe48&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2dbfe48"]])

export default __exports__